import React from 'react'
import CyclesForm from "./CyclesForm"
import Cycles from "./Cycles"

const CyclesPage = () => (
    <>
        <CyclesForm />
        <Cycles />
    </>
)

export default CyclesPage